const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/taste/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { pickEnum, pickString } from "@/lib/search-params";
import { buildPrivatePageMetaTags } from "@/lib/seo-meta";
import { getRootLoaderData } from "@/types/intl";
import { getSafeRedirectPath } from "@garimpa/lib/getSafeRedirectPath";
const CALLBACK_VALUES = ["connected", "error"] as const;
export const Route = createFileRoute("/_app/taste/")({
  validateSearch: (search: Record<string, unknown>) => ({
    discogs: pickEnum(search.discogs as string | string[] | undefined, CALLBACK_VALUES),
    redirect: getSafeRedirectPath(pickString(search.redirect))
  }),
  head: ({
    match
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const t = createTranslator({
      locale,
      messages,
      namespace: "taste"
    });
    return {
      meta: buildPrivatePageMetaTags(t("title"))
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});